import { atom } from "recoil";

const permissions = atom({
  key: "permissions",
  default: {},
});
export default {
  permissions,
};
